module.exports = __webpack_public_path__ + "static/media/TO.ec77d856.svg";